module.exports = __webpack_public_path__ + "static/media/service.83f01956.svg";